import { useEffect, useState } from 'react'
import { getRequest, postRequest } from '../../services/base'
import { useSearchParams } from 'react-router-dom'
import {
  deleteLocalStorage,
  setLocalStorageData,
} from '../../utils/LocalStorageAccess'
import { AUTH_TOKEN, MAKE_ID } from '../../constants/common'
import { isAuth } from '../../utils/auth'
import { deleteSessionStorage } from '../../utils/SessionStorage'

const Auth = () => {
  const [error, setError] = useState('Authentication in progress...')
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.has('code')) {
      generateToken(searchParams.get('code'))
    } else {
      getAuthUrl()
    }
  }, [])

  const getAuthUrl = async () => {
    let res = await getRequest('/generate_auth_redirect_url/', isAuth)
    if (res?.redirect_url) {
      window.location.href = res.redirect_url
    } else {
      setError(res.msg)
      if (res.msg === 'We are redirecting to AT sign in page') {
        window.location.href = '/users/sign_in'
      } else {
        alert(res.msg)
      }
    }
  }

  const generateToken = async (code) => {
    let res = await postRequest('/generate_oauth_token/', { code: code })
    if (res?.success) {
      setLocalStorageData(AUTH_TOKEN, res.token)
      setLocalStorageData(MAKE_ID, res.make)
      window.location.href = '/vehicles'
    } else {
      deleteLocalStorage(AUTH_TOKEN)
      deleteLocalStorage(MAKE_ID)
      deleteSessionStorage('vehicle')
      deleteSessionStorage('dtcs_list')
      setError(res?.msg)
    }
  }
  return (
    <div className="min-h-screen flex w-full">
      <div className="container mx-auto flex items-center justify-center text-2xl text-white">
        {error}
      </div>
    </div>
  )
}

export default Auth
